import { createUniqueId, splitProps } from "solid-js";

import type { BrandLogoProps } from "./types";

export default function Google(props: BrandLogoProps) {
  const [local] = splitProps(props, ["size", "class"]);
  const clipPathId = createUniqueId();
  const size = () => local.size ?? 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size()}
      height={size()}
      fill="none"
      viewBox="0 0 14 14"
      aria-hidden="true"
      class={local.class}
      style={{ "flex-shrink": 0 }}
    >
      <g clip-path={`url(#${clipPathId})`}>
        <path
          fill="#4285F4"
          d="M7 5.727v2.711h3.767a3.228 3.228 0 0 1-1.406 2.107l2.272 1.762c1.323-1.221 2.087-3.016 2.087-5.148 0-.496-.045-.973-.127-1.432H7Z"
        />
        <path
          fill="#34A853"
          d="m3.077 8.332-.512.393L.75 10.137C1.903 12.422 4.263 14 7 14c1.89 0 3.474-.624 4.633-1.693L9.36 10.544c-.624.42-1.42.675-2.361.675-1.82 0-3.366-1.228-3.92-2.883l-.003-.004Z"
        />
        <path
          fill="#FBBC05"
          d="M.75 3.863A6.914 6.914 0 0 0 0 7c0 1.133.274 2.196.75 3.137 0 .007 2.33-1.807 2.33-1.807A4.195 4.195 0 0 1 2.857 7c0-.465.083-.91.223-1.33L.75 3.863Z"
        />
        <path
          fill="#EA4335"
          d="M7 2.787c1.03 0 1.947.357 2.68 1.044l2.004-2.005C10.468.694 8.89 0 7 0A6.988 6.988 0 0 0 .75 3.863L3.08 5.67C3.634 4.015 5.18 2.787 7 2.787Z"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="#fff" d="M0 0h13.72v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
